import copy from 'copy-to-clipboard'
import { PropsWithChildren } from 'react'
import { FacebookIcon, FacebookShareButton, TwitterShareButton, XIcon } from 'react-share'

import { Button, ButtonProps } from '../button'
import { Dropdown, DropdownItem } from '../dropdown'
import { Icon } from '../icon'

interface Props extends ButtonProps {
  url: string
}

export default function ShareButton({ url, children = 'Share' }: PropsWithChildren<Props>) {
  return (
    <Dropdown
      aria-label="Share"
      trigger={
        <Button leftContent="share" className="text-default">
          {children}
        </Button>
      }
    >
      <DropdownItem leftContent={<Icon name="link" />} onClick={() => copy(url)}>
        Copy Link
      </DropdownItem>
      <DropdownItem
        as={TwitterShareButton}
        url={url}
        resetButtonStyle={false}
        leftContent={<XIcon size={24} bgStyle={{ opacity: 0 }} iconFillColor="currentColor" className="shrink-0" />}
      >
        Share on X
      </DropdownItem>
      <DropdownItem
        as={FacebookShareButton}
        url={url}
        resetButtonStyle={false}
        leftContent={
          <FacebookIcon size={24} bgStyle={{ opacity: 0 }} iconFillColor="currentColor" className="shrink-0" />
        }
      >
        Share on Facebook
      </DropdownItem>
    </Dropdown>
  )
}
